/* eslint-disable max-len */
import React from 'react';
import InputField from '../../../../../components/InputFeld';
import { PanCardRegex } from '../../../../../CommonMethods/PanCardRegex';

const SundryCreditors = ({
    recodes,
    handleOnchangeInput,
    exitVal,
    GSTError,
    toastErrorMessage,
    selectedGroupType,
}) => {
    const panCardRegex=/[A-Z]{5}[0-9]{4}[A-Z]{1}/

    /**
     * The function `handlePanCheck` checks if the `pan_number` in the `recodes` object matches a PAN
     * card regex pattern.
     * @returns The function `handlePanCheck` is returning the result of the
     * `panCardRegex.test(recodes.pan_number)` expression.
     */
    const handlePanCheck=()=>{
        return panCardRegex.test(recodes.pan_number)
    }
    return (
        <>
            {/* <!-- Sundry Creditors details section --> */}
            <div class="Sundry_Creditors_details">
                <p class="text-base font-semibold text-[#031624] mb-2">{selectedGroupType === "Sundry Debtors" ? "Debtor" : "Creditor"} Details</p>
                <div class="border border-[#D0D5DD] p-3 rounded">
                    {/* <!-- pan,gstin and address section --> */}
                    <div class="border-b border-[#D0D5DD] pl-[8%]">
                        <div class="w-full">
                            <div class="flex xl:-mx-10 2xl:-mx-[100px]">
                                <div class="w-[46%] xl:px-10 2xl:px-[100px]" style={{'padding-left':'2rem'}}>
                                    <div class="w-full">
                                        <div class="flex items-center w-full mb-4">
                                            <label for="panName" class="text-f7 font-normal text-[#031624] min-w-[65px] inline-flex">PAN<span class="req-fld-astrk">*</span></label>
                                            <InputField
                                                inputId={"pan_number"}
                                                inputLabel={"PAN"}
                                                inputType={"text"}
                                                inputPlaceholder={"Enter PAN"}
                                                inputDisabled={false}
                                                inputErrorMessage={(exitVal && (recodes?.pan_number === "" || recodes?.pan_number === null || (toastErrorMessage === 'Please enter valid details'))) ? "Account Holder Name is Mandatory" : ""}
                                                inputMaxLength={10}
                                                inputValue={recodes.pan_number}
                                                inputChange={handleOnchangeInput}
                                                optional={true}
                                                inputWidth={`295px`}
                                                isMandatoryField={true}
                                            />
                                        </div>
                                        <div class="flex items-center w-full mb-4">
                                            <label for="gstin" class="text-f7 font-normal text-[#031624] min-w-[65px] inline-flex">GSTIN</label>
                                            <InputField
                                                inputId={"gst_number"}
                                                inputLabel={"GSTIN"}
                                                inputType={"text"}
                                                inputPlaceholder={"Enter GSTIN"}
                                                inputDisabled={false}
                                                inputErrorMessage={exitVal && GSTError ? 'Length of GSTIN should be 15 characters': ''}
                                                inputMaxLength={15}
                                                inputValue={recodes.gst_number}
                                                inputChange={handleOnchangeInput}
                                                optional={true}
                                                inputWidth={`295px`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="w-[54%] xl:px-10 2xl:px-[100px]">
                                    <div class="flex items-center w-full">
                                        <label for="Billing_Address" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex self-start pt-2.5">Billing Address<span class="req-fld-astrk">*</span></label>
                                        <div class={` error_border w-full`}>
                                            <textarea
                                                id="billing_address" 
                                                value={recodes.billing_address}
                                                onChange={(e) => handleOnchangeInput(e)}    
                                                className={`w-full txt-fld ${(exitVal && recodes?.billing_address === "") ? "redBorder" : ""}`}
                                                placeholder="Enter Billing Address"
                                                style={{'height':'92px'}}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- bank account details section --> */}
                    <div class="mt-4">
                        <div class="flex xl:-mx-10 2xl:-mx-[100px]">
                            <div class="w-[46%] xl:px-10 2xl:px-[100px]">
                                <div class="w-full">
                                    <div class="flex items-center w-full mb-4">
                                        <label for="accName" class="text-f7 font-normal text-[#031624] min-w-[150px] inline-flex">Acc. Holder Name<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"account_holder_name"}
                                            inputLabel={"Account Holder Name"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Acc. Holder Name"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.account_holder_name === "") ? "Account Holder Name is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.account_holder_name}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full mb-4">
                                        <label for="Account_No" class="text-f7 font-normal text-[#031624] min-w-[150px] inline-flex">Account No.<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"account_number"}
                                            inputLabel={"Account Number"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Account No."}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && (recodes?.account_number === null || recodes?.account_number === "")) ? "Account Name is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.account_number}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="w-[50%] xl:pl-[82px] 2xl:pl-[100px]">
                                <div class="w-[85%]">
                                    <div class="flex items-center w-full mb-4">
                                        <label for="Bank_Name" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">Bank Name<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"bank_name"}
                                            inputLabel={"Bank Name"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter Bank Name"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.bank_name === "") ? "Bank Name is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.bank_name}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full mb-4">
                                        <label for="IFSC_Code" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">IFSC Code<span class="req-fld-astrk">*</span></label>
                                        <InputField
                                            inputId={"ifsc_code"}
                                            inputLabel={"IFSC Code"}
                                            inputType={"text"}
                                            inputPlaceholder={"Enter IFSC Code"}
                                            inputDisabled={false}
                                            inputErrorMessage={(exitVal && recodes?.ifsc_code === "") ? "IFSC Code is Mandatory" : ""}
                                            inputMaxLength={30}
                                            inputValue={recodes.ifsc_code}
                                            inputChange={handleOnchangeInput}
                                            isMandatoryField={true}
                                        />
                                    </div>
                                    <div class="flex items-center w-full">
                                        <label for="Swift_Transfer_Code" class="text-f7 font-normal text-[#031624] min-w-[160px] inline-flex">Swift Transfer Code</label>
                                        <InputField
                                            inputId={"swift_transfer_code"}
                                            inputLabel={"Swift Transfer Code"}
                                            inputType={"text"}
                                            inputMaxLength={30}
                                            inputPlaceholder={"Enter Swift Transfer Code"}
                                            inputDisabled={false}
                                            inputErrorMessage={""}
                                            inputValue={recodes.swift_transfer_code}
                                            inputChange={handleOnchangeInput}
                                            optional={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SundryCreditors;
